<template>
  <v-dialog 
    v-model="dialog"
    fullscreen 
    full-width
    transition="none"
  >
    <v-container 
      bg 
      fluid 
      fill-height 
      class="browser"
    >
      <v-layout 
        justify-center 
        align-center
      >
        <v-card flat>
          <v-card-text>
            <h1 class="title-text">{{ nonPublishableMsg.title }}</h1>
            <div class="mt-3 mb-3 white">
              <span class="message">{{ nonPublishableMsg.msg }}</span>
            </div>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-container>
  </v-dialog>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  name: 'browser',
  data () {
    return {
      dialog: true
    }
  },
  computed: {
    ...mapGetters('config', [
      'colors', 'nonPublishableMsg'
    ])
  }
}
</script>

<style scoped>
.browser {
  background-color: white;
}
.title-text {
  text-transform: uppercase;
  font-weight: 800;
}
.message {
  white-space: pre-wrap;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/NonPublished.vue